import { all } from "redux-saga/effects";
import { watchAddressSaga } from "./addressSaga";
import { watchAppSaga } from "./appSaga";
import { watchBlockSaga } from "./blockSaga";
import { watchBlocksSaga } from "./blocksSaga";
import { watchChainSaga } from "./chainSaga";
import { watchPriceSaga } from "./priceSaga";
import { watchTxSaga } from "./txSaga";
import { watchTxsSaga } from "./txsSaga";

// Root Saga
export default function* rootSaga() {
  yield all([
    watchAddressSaga(),
    watchAppSaga(),
    watchBlockSaga(),
    watchBlocksSaga(),
    watchChainSaga(),
    watchPriceSaga(),
    watchTxSaga(),
    watchTxsSaga(),
  ]);
}
